// extracted by mini-css-extract-plugin
export default {"root":"_1x2pOzvy","messenger":"_2EPdBnlF","facebook":"_1Iw3f4jo","whatsapp":"_3Re3QnW8","telegram":"hqZEzHw8","viber":"NtecOOrD","btn":"gulnjTcO","instaContainer":"_3xhAqway"};